const account = {
  Sections: {
    BasicInfo: "Basic Info",
    Security: "Security",
    Credentials: "Credentials",
    ShippingAddresses: "Shipping addresses",
    PatientAddresses: "Patient addresses",
    PaymentInfo: "Payment info",
    Preferences: "Preferences",
    BrandAgreementsMAPs: "Brand agreements & MAPs",
    TaxExemptionCertification: "Tax exemption certification",
  },
  MyOrders: "My Orders",
  NotYou: "Not You?",
  OrderHistory: "Order History",
  OrderInformation: "Order Information",
  PaymentInformation: "Payment Information",
  IsNetTerms: "Net Terms",
  AccountSettings: "Account settings",
  OrderDetails: {
    CustomerPO: "Customer PO",
    CustomerID: "Customer ID",
    LineItems: {
      Brand: "Brand",
      ItemCode: "Item Code",
      Total: "Total",
      Product: "Product",
      Price: "Price",
      Items: "Items",
    },
    NA: "N/A",
    OrderDate: "Order Date",
    Subtotal: "Subtotal",
    Shipping: "Shipping",
    DropShipFee: "Dropship fee",
    Taxes: "Taxes",
    Discount: "Discount",
    SoldTo: "Billed to",
    ShipTo: "Shipped to",
    ShipmentState: "Shipment State",
    SalesOrder: "Sales Order",
    Title: "Order Details",
    PlacedAt: "Ordered on {{ placedAt }}",
    Order: "Order <1>{{ number }}</1>",
    Total: "Total",
    ShipmentPdf: "Shipment PDF",
    SeeAll: "See All",
    Shipped: "Shipped",
    NotShipped: "Not Shipped",
    Shipment: "Shipment #{{ number }}",
    ShippedOn: "Shipped on {{ date }}",
    DownloadPDF: "Download PDF",
    TrackStatus: "Track status",
  },
  Orders: {
    Order: "Order",
    ShipTo: "Ship to",
    Status: "Status",
    Items: "Items",
    Total: "Total",
    ViewDetails: "View Details",
  },
  Backorder: {
    CancelBackorderedItem: "Cancel backordered item",
    CancelBackorderItemMessage: "Are you sure you want to cancel this backorder item?",
    Close: "Close",
    CancelItem: "Cancel item",
  },
  Reorder: {
    Title: "Reorder Products",
    LastOrdered: "Last Ordered",
    ProductName: "Product name",
    Price: "Price",
    QuantityOrdered: "Qty Ordered",
    AddToCart: "ADD TO CART",
  },
  General: {
    Avatar: "Avatar",
    GeneralInfo: "General Info",
    ProfessionalInfo: "Professional Info",
    EditName: "Edit name",
    Title: "Title",
    FirstName: "First name",
    LastName: "Last name",
    Suffix: "Suffix",
    Saved: "Saved!",
    PhoneNumber: "Phone number",
    Update: "Update",
    Address1: "Address 1",
    Address2: "Address 2",
    City: "City",
    State: "State",
    Country: "Country",
    PostalCode: "Zip",
    BusinessName: "Business name",
    FormError: {
      InvalidEmail: "Email is invalid.",
      InvalidPhoneNumber: "Phone number is invalid.",
      InvalidBio: "Bio is invalid.",
    },
    FormSuccess: {
      PublicProfile: "Public profile updated successfully",
      EmailUpdated: "Email updated successfully",
    },
    FormValidation: {
      Required: "This field is required.",
      Email: {
        Invalid: "Please enter a valid email",
      },
      Phone: {
        Invalid: "Please enter a valid phone number",
        LengthError: "Must be at least 8 digits.",
      },
    },
  },
  SignOut: "Sign Out",
  SettingsTitle: "Settings",
  SortBy: "Sort by",
  Title: "MY ACCOUNT",
  WelcomeUser: "Welcome, {{ userName }}",
  ViewByDate: "View by date",
  ViewAll: "All Dates",
  Last7Days: "Last 7 Days",
  Last30Days: "Last 30 Days",
  Last90Days: "Last 90 Days",
  Search: "Search",
  FindOrders: "Find Orders",
  OrderDate: "Order Date",
  OrderNumber: "Order Number",
  ShippedTo: "Shipped To",
  Total: "Total",
  Items: "Items",
  Invoice: "Invoice",
  TrackOrder: "Track Order",
  LoadMore: "Load More",
  NoOrders: "You haven't placed any orders yet.",
  Add: "+ Add",
  Stay: "Stay",
  Leave: "Leave",
  LeaveThisPage: "Leave this page?",
  LeaveThisPageMessage: "The information you are currently editing will not be saved.",
  CreditCards: {
    Title: "Credit Cards",
    NoCreditCardsTitle: "Make purchases fast by saving credit cards",
    NoCreditCardsSubtitle: "Credit cards saved during purchases will be shown here.",
    SetDefault: "Set as Default",
    DeleteCreditCardHeading: "Delete credit card?",
    Delete: "Delete",
    FormSuccess: "Credit card removed successfully",
    FormError: "An error occurred while trying to remove your card. Please try again.",
  },
  Update: "Update",
  Security: {
    Email: "Email",
    LoginEmail: "Login email",
    Password: "Password",
    CurrentPassword: "Current password",
    NewPassword: "New password",
    Updated: "Security fields updated successfully",
  },
  SecurityErrors: {
    ServerSidePasswordInvalid: "is invalid",
    CurrentPasswordRequired: "Current password required",
    CurrentPasswordInvalid: "Invalid password",
    NewPasswordRequired: "New password required",
    NewPasswordInvalid: "New password must be at least 8 characters",
  },
  Preferences: {
    Title: "Notifications email",
    Body: "Notifications will be sent to this email address.",
    InputLabel: "Notifications email",
    ErrorInfo: "Please provide a valid email address",
  },
  TaxExemptionCertification: {
    Title: "Tax Exemption Certification",
    Subtitle:
      "Many states offer sales tax exemptions. When sales tax exemptions apply, Emerson Ecologics will not charge or collect tax for applicable products on a wholesale order when the purchaser has provided a valid resale or other applicable certificate which matches their ship-to state.",
    LearnMore: "Read here for more information on tax exemption certificates.",
    HelpText:
      "*This information isn't legal or tax advice. Consult your tax advisor for specific tax obligations",
    RequestACertificate: "Request a Tax Exemption Certificate",
    Steps: `
      <0>Use the button below to request a tax exemption certificate via CertCapture.</0>
      <1>Emerson Ecologics will review the request. This can take up to 5 business days.</1>
      <2>If not approved, we will email you with needed corrections.</2>
      <3>Once approved, no sales tax will be charged from the certificate's effective date.</3>`,
    GenerateMyLink: "Generate my link",
    GoToCertExpress: "Go to CertExpress",
    CertExpressStatus: "CertExpress Status",
    CertExpressStatusDescription:
      "Once one tax exemption certificate is submitted to CertCapture, your tax exemption certificate status will be shown below. You may also visit the CertExpress portal at any time using the link above on this page to check your status and manage your certificate(s).",
    ReasonUnknown:
      "If the reason for your exemption is not listed in CertExpress, please reach out to <1>{{taxComplianceEmail}}</1>",
  },
} as const;

export { account };
